import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { MyCampaignsImg } from '../../../static/constant/imgConstants';
import DynamicImagePreview from "./DynamicImagePreview";
import { uploadCampaignFile } from "../../../store/campaignStore/actions/CreateCampaignActions/uploadCampaignFileActions";
import { uploadReferenceVideo } from "../../../store/campaignStore/actions/CreateCampaignActions/uploadReferenceVideoActions";
import {
    getAllBannerTemplate
} from "../../../store/campaignStore/actions/CreateCampaignActions/getAllBannerTemplateActions";
import CampaignDate from '../BrandCampaignCreation/CampaignDate';
import { useToast } from '../../../hooks/useToast';
import { FaTimesCircle } from "react-icons/fa";
import { useState } from 'react';
import { setBrandCampaignCreationData } from "../../../store/publicStore/actions/utilsActions/utilsActions";

const Banner = ({
    selectedBanner,
    setSelectedBanner,
    setStartDate,
    setEndDate,
    startDate,
    endDate,
    errors,
    setErrors,
    setUploadedBannerImage,
    uploadedBannerImage,
    referenceVideoUpload,
    setReferenceVideoUpload,
    setReferenceVideoFile,
    descriptionLink,
    setDescriptionLink,
    loading,
    setLoading,
}) => {
    const dispatch = useDispatch();
    const Toast = useToast();
    const [refVideoFileName, setRefVideoFileName] = useState('');

    const getAllBannerTemplateReducerData = useSelector(state => state.getAllBannerTemplateReducer.data) || [];
    const { brandCampaignCreationData } = useSelector((state) => state.utilReducers);

    // Function to handle updating content_or_url in elements
    const handleInputChange = (index, value, localUrl) => {
        const updatedElements = selectedBanner.templateDataJson.elements.map((element, i) => {
            if (i === index) {
                return { ...element, content_or_url: value, localUrl: localUrl }; // Update the content_or_url of the specific element
            }
            return element;
        });

        // Update the state with the modified elements
        setSelectedBanner(prevState => ({
            ...prevState,
            templateDataJson: {
                ...prevState.templateDataJson,
                elements: updatedElements,
            },
        }));
    };

    const handleImageUpload = (index, file) => {

        setErrors((prevState) => {
            const {
                ["handleImageUpload"]: _,
                ...updatedObject
            } = prevState;
            return updatedObject;
        })

        if (!file || !file.type.startsWith("image/")) {
            setErrors((prevState) => ({
                ...prevState,
                handleImageUpload: "Please upload a valid image file",
            }));
            return;
        }

        const localUrl = URL.createObjectURL(file); // Create local URL for preview

        setUploadedBannerImage(file.name);

        dispatch(uploadCampaignFile({ file }, (response, status) => {
            // Callback to update content_or_url with the returned image URL
            if (status === 200) {
                handleInputChange(index, response, localUrl);
            } else {
                Toast(response, 'error');
            }
        }));
    };

    useEffect(() => {
        dispatch(getAllBannerTemplate());
    }, []);

    const removeBannerImage = () => {

        setUploadedBannerImage(null);
        setSelectedBanner({
            ...selectedBanner,
            templateDataJson: {
                ...selectedBanner.templateDataJson,
                elements: selectedBanner.templateDataJson.elements.map((item) =>
                    item.type === "image" ? { ...item, localUrl: '' } : item
                ),
            },
        });


        dispatch(
            setBrandCampaignCreationData({
                basicDetails: {
                    campaignName: brandCampaignCreationData?.basicDetails?.campaignName,
                    campaignPurpose: brandCampaignCreationData?.basicDetails?.campaignPurpose,
                    platform: brandCampaignCreationData?.basicDetails?.platform,
                    campaignType: brandCampaignCreationData?.basicDetails?.campaignType,
                    referralCode: brandCampaignCreationData?.basicDetails?.referralCode,
                    selectedBrandId: brandCampaignCreationData?.basicDetails?.selectedBrandId,
                },
                contentDetails: {
                    startDate: brandCampaignCreationData?.contentDetails?.startDate,
                    endDate: brandCampaignCreationData?.contentDetails?.endDate,
                    bannerTemplate: { templateDataJson: { elements: brandCampaignCreationData?.contentDetails?.bannerTemplate.templateDataJson.elements.filter((item) => item.type === 'text') } },
                    selectedBannerName: null,
                    videoPosition: brandCampaignCreationData?.contentDetails?.videoPosition,
                    mediaFileLink: brandCampaignCreationData?.contentDetails?.mediaFileLink,
                    mediaFileName: brandCampaignCreationData?.contentDetails?.mediaFileName,
                    script: brandCampaignCreationData?.contentDetails?.script,
                    dialogue: brandCampaignCreationData?.contentDetails?.dialogue,
                    backgroundColor: brandCampaignCreationData?.contentDetails?.backgroundColor,
                    otherProperties: brandCampaignCreationData?.contentDetails?.otherProperties,
                    isLocationRequired: brandCampaignCreationData?.contentDetails?.isLocationRequired,
                    isBrandApprovalRequired: brandCampaignCreationData?.contentDetails?.isBrandApprovalRequired,
                    uploadDuration: brandCampaignCreationData?.contentDetails?.uploadDuration,
                },
                audienceDemographicDetails: {
                    ageGroup: brandCampaignCreationData?.audienceDemographicDetails?.ageGroup,
                    country: brandCampaignCreationData?.audienceDemographicDetails?.country,
                    niche: brandCampaignCreationData?.audienceDemographicDetails?.niche,
                    region: brandCampaignCreationData?.audienceDemographicDetails?.region,
                    gender: brandCampaignCreationData?.audienceDemographicDetails?.gender,
                    state: brandCampaignCreationData?.audienceDemographicDetails?.state,
                    city: brandCampaignCreationData?.audienceDemographicDetails?.city,
                }
            })
        );

    }

    return (
        <div className="w-full mb-6">
            <div className="flex flex-col md:flex-row justify-between items-start">
                <div className="flex justify-between items-start flex-wrap w-full md:w-[69%]">
                    <div className="">
                        <h2 className="text-[1.6rem] text-[#111729] inter-font mb-6">
                            Select Banner<span className="text-[1.6rem] text-[#E3351D]">*</span>
                        </h2>
                        <div className="flex justify-start items-center flex-wrap">
                            {getAllBannerTemplateReducerData.length > 0 ?
                                getAllBannerTemplateReducerData?.map((banners, idx) => {
                                    return (
                                        <div
                                            key={idx}
                                            className={`w-[18rem] h-[19rem] flex flex-col items-center justify-between mr-[2rem] border rounded-lg 
                                                ${banners?.isActive ? "cursor-pointer" : "cursor-not-allowed"} 
                                                ${banners?.bannerTemplateId === selectedBanner?.bannerTemplateId ? "border-[#0D9B50] bg-[#DBEAE6]/40" : "border-[#E3E8EF] bg-[#FFFFFF]"} hover:border-[#0D9B50] hover:bg-[#DBEAE6]/20`
                                            }
                                        >
                                            <div
                                                className="w-auto h-auto m-auto"
                                                onClick={() => {
                                                    if (banners?.isActive) {
                                                        setSelectedBanner(banners);
                                                        setErrors((prevState) => {
                                                            const { ["selectedBanner"]: _, ...updatedObject } = prevState;
                                                            return updatedObject;
                                                        })
                                                    }
                                                }
                                                }
                                            >
                                                <img src={banners.sampleImageUrl} alt="Banner Icon" className="w-full h-full" />
                                            </div>
                                        </div>
                                    )
                                })
                                :
                                <div className="text-[1.4rem]">
                                    No banners available.
                                </div>
                            }
                        </div>
                    </div>
                    {errors.selectedBanner && (
                        <p className="text-red-500 text-[1.6rem] inter-font font-[400]">
                            {errors.selectedBanner}
                        </p>
                    )}

                    <div className="w-full flex justify-between items-start flex-wrap my-[2.4rem]">
                        {selectedBanner != null && selectedBanner.isActive && (
                            selectedBanner.templateDataJson?.elements?.map((element, idx) => (
                                <div className={`w - full md: w - [49 %] ${element.type === 'text' ? "" : "flex flex-col justify-start items-start"} `} key={idx}>
                                    <label className="text-[1.6rem] border-gray-500 inter-font">{element.type.charAt(0).toUpperCase() + element.type.slice(1)}<span className='text-[#E3351D]'>*</span></label>
                                    {element.type === 'text' ? (
                                        <>
                                            <input
                                                className="w-full text-[1.4rem] inter-font px-4 py-4 border border-gray-300 rounded-lg focus:outline-none my-[1rem]"
                                                type="text"
                                                value={element.content_or_url}
                                                onChange={(e) => {
                                                    handleInputChange(idx, e.target.value);
                                                    setErrors((prevState) => {
                                                        const { ["handleText"]: _, ...updatedObject } = prevState;
                                                        return updatedObject;
                                                    })
                                                }}
                                            />
                                            {errors.handleText && (
                                                <p className="text-red-500 text-[1.6rem] inter-font font-[400]">
                                                    {errors.handleText[idx]}
                                                </p>
                                            )}
                                        </>

                                    ) : (
                                        <div className="my-[1rem] w-full">
                                            {uploadedBannerImage ?
                                                <div className="w-full text-[1.4rem] inter-font px-4 py-4 bg-[#FFF] border border-gray-300 rounded-lg focus:outline-none flex">
                                                    <div className="w-[90%] inter-font">
                                                        {uploadedBannerImage}
                                                    </div>
                                                    <FaTimesCircle size={16} color={"#f00"} className="ml-4 cursor-pointer" onClick={() => { removeBannerImage(); }} />
                                                </div>
                                                :
                                                <input
                                                    className="w-full text-[1.6rem] inter-font px-4 py-2 bg-[#FFF] border border-gray-300 rounded-lg focus:outline-none"
                                                    type="file"
                                                    accept="image/*"
                                                    onChange={(e) => {
                                                        if (e.target.files[0]) {
                                                            handleImageUpload(idx, e.target.files[0]);
                                                        }
                                                    }}
                                                />
                                            }
                                            {errors?.handleImageUpload && (
                                                <p className="text-red-500 text-[1.6rem] inter-font font-[400]">
                                                    {errors.handleImageUpload}
                                                </p>
                                            )}
                                        </div>
                                    )}
                                </div>
                            ))
                        )}

                    </div>

                    {/* Preview Section for Mobile - Shown only on mobile devices */}
                    <div className="w-full md:hidden mb-[2.4rem]">
                        {selectedBanner != null && selectedBanner.isActive ?
                            <div className="w-full">
                                <h2 className="text-[1.4rem] text-[#111729] inter-font font-[400] mb-1">Preview</h2>
                                <div className="w-full h-full">
                                    {selectedBanner?.templateDataJson ? (
                                        <DynamicImagePreview elements={selectedBanner.templateDataJson.elements} />
                                    ) : (
                                        <img src={selectedBanner.sampleImageUrl} alt="Banner Icon"
                                            className="w-full h-full" />
                                    )}
                                </div>
                            </div> : ''}
                    </div>

                    <CampaignDate
                        startDate={startDate}
                        endDate={endDate}
                        errors={errors}
                        setStartDate={setStartDate}
                        setEndDate={setEndDate}
                        setErrors={setErrors}
                        type={"BANNER"}
                    />

                    {/* ── Reference Guidance Video (optional) ────────────────────── */}
                    <div className="w-full mb-[2rem] mt-[1rem]">
                        <label className="text-[1.6rem] text-[#111729] inter-font font-[400] leading-relaxed pb-2">
                            Reference Guidance Video
                            <span className="text-[1.4rem] text-gray-400 ml-2">(optional)</span>
                        </label>
                        <div className="flex items-center gap-4 mt-[1rem]">
                            <input type="file" accept="video/*" className="hidden" id="bannerRefVideoUpload"
                                disabled={loading}
                                onChange={(e) => {
                                    const selectedFile = e.target.files[0];
                                    if (!selectedFile) return;
                                    if (!selectedFile.type.startsWith("video/")) {
                                        setErrors((prevState) => ({
                                            ...prevState,
                                            referenceVideoUpload: "Please upload a valid video file for reference guidance",
                                        }));
                                        return;
                                    }
                                    setErrors((prevState) => {
                                        const { ["referenceVideoUpload"]: _, ...updatedObject } = prevState;
                                        return updatedObject;
                                    });
                                    setLoading(true);
                                    setRefVideoFileName(selectedFile.name);
                                    dispatch(uploadReferenceVideo({ file: selectedFile }, (status, response, message) => {
                                        if (status === 200) {
                                            setReferenceVideoUpload(response);
                                            setLoading(false);
                                        } else {
                                            Toast(message || "Upload failed", "error");
                                            setLoading(false);
                                            setReferenceVideoUpload('');
                                            setRefVideoFileName('');
                                        }
                                    }));
                                }}
                            />
                            <label htmlFor="bannerRefVideoUpload" className={`cursor-pointer border border-gray-300 rounded-lg px-6 py-3 text-[1.4rem] text-[#111729] inter-font font-[400] hover:bg-gray-50 ${loading ? 'opacity-50 pointer-events-none' : ''}`}>
                                {loading ? "Uploading..." : "Choose Video"}
                            </label>
                            {refVideoFileName ? (
                                <span className="text-[1.4rem] text-gray-600 inter-font">{refVideoFileName}</span>
                            ) : referenceVideoUpload ? (
                                <span className="text-[1.4rem] text-blue-600 inter-font">Video Uploaded</span>
                            ) : null}
                            {(refVideoFileName || referenceVideoUpload) && (
                                <button type="button" onClick={() => { setReferenceVideoFile(null); setReferenceVideoUpload(''); setRefVideoFileName(''); }} className="text-[1.2rem] text-red-500 hover:underline">
                                    Remove
                                </button>
                            )}
                        </div>
                        {errors?.referenceVideoUpload && (
                            <p className="text-red-500 text-[1.4rem] inter-font font-[400] mt-1">
                                {errors?.referenceVideoUpload}
                            </p>
                        )}
                    </div>

                    {/* ── Description Link (optional) ─────────────────────────────── */}
                    {/* <div className="w-full mb-[2rem]">
                        <label className="text-[1.6rem] text-[#111729] inter-font font-[400] leading-relaxed pb-2">
                            Description Link
                            <span className="text-[1.4rem] text-gray-400 ml-2">(optional)</span>
                        </label>
                        <input type="url" value={descriptionLink || ''} onChange={(e) => setDescriptionLink(e.target.value)}
                            placeholder="https://example.com/reference"
                            className="w-full border border-gray-300 text-[1.6rem] inter-font font-[400] mt-[1rem] rounded-lg p-4 bg-white text-gray-900 shadow-sm"
                        />
                    </div> */}
                </div>

                {/* Preview Section for Desktop - Shown only on desktop/tablet */}
                <div className="hidden md:block w-[20%]">
                    {selectedBanner != null && selectedBanner.isActive ?
                        <div className="w-full">
                            <h2 className="text-[1.4rem] text-[#111729] inter-font font-[400] mb-1">Preview</h2>
                            <div className="w-full h-full">
                                {selectedBanner?.templateDataJson ? (
                                    <DynamicImagePreview elements={selectedBanner.templateDataJson.elements} />
                                ) : (
                                    <img src={selectedBanner.sampleImageUrl} alt="Banner Icon"
                                        className="w-full h-full" />
                                )}
                            </div>
                        </div> : ''}
                </div>
            </div>
        </div>
    );
};

export default Banner;